const SITE_URL = (
  process.env.REACT_APP_SITE_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  ""
).replace(/\/+$/, "");

const WHATSAPP_MESSAGE =
  "Merhaba, Lavenza Masaj Salonu için randevu almak istiyorum.";

export const site = {
  name: "Lavenza Masaj Salonu Bursa",
  shortName: "Lavenza",
  tagline: "Masaj Salonu · Bursa Nilüfer",
  siteUrl: SITE_URL,
  phoneDisplay: "+90 542 164 42 14",
  phoneShort: "0542 164 42 14",
  phoneE164: "+905421644214",
  phoneTel: "tel:+905421644214",
  whatsappUrl: `https://wa.me/905421644214?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
  instagram: "https://instagram.com/lavenzaspabursa",
  address: {
    street: "Konak Mahallesi, Kurşunlu Sokak, Kat:1 Daire:2",
    locality: "Nilüfer",
    region: "Bursa",
    country: "TR",
    full: "Konak Mahallesi, Kurşunlu Sokak, Kat:1 Daire:2, Nilüfer, Bursa, Türkiye",
  },
  openingHours: {
    text: "Her gün 10:00 – 04:00",
    opens: "10:00",
    closes: "04:00",
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
  },
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Konak+Mahallesi+Kur%C5%9Funlu+Sokak+Nil%C3%BCfer+Bursa&output=embed",
  mapsDirectionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Konak+Mahallesi+Kur%C5%9Funlu+Sokak+Nil%C3%BCfer+Bursa",
  mapsSearchUrl:
    "https://www.google.com/maps/search/?api=1&query=Konak+Mahallesi+Kur%C5%9Funlu+Sokak+Nil%C3%BCfer+Bursa",
  heroImage: "/images/lavenza-bursa-masaj-salonu.webp",
  heroImageAlt: "Lavenza Bursa masaj salonu iç mekan",
  areaServed: ["Bursa", "Nilüfer", "Konak Mahallesi"],
  priceNote: "Fiyat ve süre bilgisi için WhatsApp'tan yazın.",
  services: [
    {
      slug: "klasik",
      name: "Klasik Masaj",
      subtitle: "Tüm vücut için akıcı ve dengeli rahatlama",
      path: "/bursa-klasik-masaj",
      image: "/images/bursa-klasik-masaj.webp",
      alt: "Klasik masaj için hazırlanan yağ ve havlular",
      short:
        "Uzun, akıcı hareketlerle kas gerginliğini azaltan ve genel rahatlama sağlayan en bilinen masaj türü.",
      detail:
        "Klasik masaj, orta şiddette baskı ve ritmik hareketlerle kasların gevşemesini ve dolaşımın desteklenmesini hedefler. Yoğun bir haftanın ardından genel bir rahatlama arayan misafirlerimiz için ideal bir başlangıçtır. Seans öncesinde tercih ettiğiniz baskı seviyesini konuşur, uygulamayı size göre ayarlarız.",
    },
    {
      slug: "medikal",
      name: "Medikal Masaj",
      subtitle: "Belirli kas gruplarına odaklı hedefli uygulama",
      path: "/bursa-medikal-masaj",
      image: "/images/bursa-medikal-masaj.webp",
      alt: "Medikal masaj uygulama odası",
      short:
        "Belirli kas gruplarındaki sertlik ve gerginliğe odaklanan, ihtiyaca göre planlanan hedefli uygulama.",
      detail:
        "Medikal masaj; boyun, sırt, bel ve omuz gibi bölgelerde biriken gerginlik ve hareket kısıtlılığına odaklanır. Uzun süre masa başında çalışanlar ya da fiziksel aktivite sonrası yoğunluk hissedenler için uygun bir seçenek olabilir. Uygulama öncesinde şikâyetleriniz dinlenir ve seans buna göre planlanır.",
    },
    {
      slug: "soft",
      name: "Soft Masaj",
      subtitle: "Hafif dokunuşlarla derin gevşeme",
      path: "/bursa-soft-masaj",
      image: "/images/nilufer-soft-masaj.webp",
      alt: "Soft masaj için sakin spa ortamı, mumlar ve taşlar",
      short:
        "Hafif dokunuşlar ve yavaş ritimle uygulanan, tamamen gevşemeye odaklı nazik masaj.",
      detail:
        "Soft masaj, düşük baskı ve yavaş bir tempo ile uygulanır; amaç zihinsel ve bedensel olarak tamamen gevşemektir. Yoğun baskıdan kaçınan, masaj deneyimine yeni başlayan veya sadece sakin bir mola arayan misafirlerimiz tarafından tercih edilir.",
    },
    {
      slug: "kese-kopuk",
      name: "Kese & Köpük",
      subtitle: "Geleneksel arınma ve ferahlık ritüeli",
      path: "/masaj-hizmetleri#kese-kopuk",
      image: "/images/lavenza-bursa-masaj-salonu.webp",
      alt: "Kese ve köpük uygulaması için hazırlanan salon",
      short:
        "Geleneksel hamam kültüründen gelen, cildi arındıran ve ferahlatan kese ile bol köpüklü yıkama.",
      detail:
        "Kese uygulaması cildi ölü hücrelerden arındırır; ardından gelen bol köpüklü yıkama hem ferahlatır hem de cildi masaja hazırlar. Klasik veya soft masaj ile birlikte tercih edildiğinde bütünsel bir spa ritüeline dönüşür.",
    },
  ],
  regions: [
    { label: "Bursa Masaj Salonu", path: "/bursa-masaj-salonu" },
    { label: "Nilüfer Masaj Salonu", path: "/nilufer-masaj-salonu" },
    { label: "Konak Masaj Salonu", path: "/konak-masaj-salonu" },
    { label: "Bursa Spa", path: "/bursa-spa" },
    { label: "Nilüfer Spa Merkezi", path: "/nilufer-spa" },
    { label: "Bursa Masaj Rehberi", path: "/bursa-masaj" },
    { label: "Nilüfer Masaj Rehberi", path: "/nilufer-masaj" },
    { label: "Konak Masaj Rehberi", path: "/konak-masaj" },
  ],
  landingLinks: [
    { label: "Bursa Masaj Salonu", path: "/bursa-masaj-salonu" },
    { label: "Nilüfer Masaj Salonu", path: "/nilufer-masaj-salonu" },
    { label: "Konak Masaj Salonu", path: "/konak-masaj-salonu" },
    { label: "Klasik Masaj Bursa", path: "/bursa-klasik-masaj" },
    { label: "Medikal Masaj Bursa", path: "/bursa-medikal-masaj" },
    { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
    { label: "Bursa Spa", path: "/bursa-spa" },
    { label: "Nilüfer Spa", path: "/nilufer-spa" },
    { label: "Bursa Masaj", path: "/bursa-masaj" },
    { label: "Nilüfer Masaj", path: "/nilufer-masaj" },
    { label: "Konak Masaj", path: "/konak-masaj" },
  ],
};

export const absUrl = (path) => `${site.siteUrl}${path}`;
